import React from 'react';
import { motion } from 'framer-motion';
import Calculator from './components/Calculator';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-indigo-100">
      <Header />
      
      <main className="container mx-auto px-4 py-8 max-w-4xl flex-grow">
        <Calculator />
      </main>
      
      <Footer />
    </div>
  );
}

export default App;